import { render, staticRenderFns } from "./AddCommentReply.vue?vue&type=template&id=3957b362&scoped=true"
import script from "./AddCommentReply.vue?vue&type=script&lang=js"
export * from "./AddCommentReply.vue?vue&type=script&lang=js"
import style0 from "./AddCommentReply.vue?vue&type=style&index=0&id=3957b362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3957b362",
  null
  
)

export default component.exports